import { useLocation } from "react-router-dom";
import { usePageMeta } from "../seo";
import { Clock, MapPin, ShieldCheck, ArrowUpRight, Star } from "lucide-react";
import { InquiryForm } from "../components/InquiryForm";
import { Reveal } from "../components/motion";
import { HONEYBOOK_URL, GOOGLE_BUSINESS_URL } from "../data/site";

const ASSURANCES = [
    { icon: Clock, text: "Personal reply within 24 hours" },
    { icon: MapPin, text: "Serving McKinney & all of DFW" },
    { icon: ShieldCheck, text: "Flexible weather reschedule policy" },
];

export default function Contact() {
    const location = useLocation();

    usePageMeta(
        "Book Now | Enchanting Escapes — Luxury Event Styling in McKinney, TX",
        "Book your luxury picnic or styled outdoor event in McKinney, Dallas, Frisco, Plano and DFW — inquire through HoneyBook or send a quick note."
    );

    return (
        <main data-testid="book-page">
            <section className="py-20 sm:py-28">
                <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-5 gap-12 lg:gap-16">
                    <div className="lg:col-span-2">
                        <Reveal>
                            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#C18E8B] mb-4">
                                Book Your Escape
                            </p>
                            <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-[#2D230A] leading-tight">
                                Your celebration begins with an inquiry
                            </h1>
                            <p className="mt-5 text-[#6E5B3D] leading-relaxed">
                                Tell us about your proposal, bridal shower, birthday,
                                anniversary or date night — anywhere in McKinney, Dallas,
                                Frisco, Plano or the greater DFW area. We'll reply with
                                availability, a tailored recommendation and next steps to
                                reserve your date.
                            </p>
                        </Reveal>
                        <Reveal delay={0.15}>
                            <a
                                href={HONEYBOOK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="book-honeybook-primary-cta"
                                className="group mt-8 inline-flex items-center gap-2 bg-[#554011] hover:bg-[#3D2E0A] text-[#FAF7F2] px-9 py-4 rounded-full font-accent text-xs uppercase tracking-[0.18em] transition-all duration-300 shadow-md hover:shadow-xl hover:scale-[1.04]"
                            >
                                Open Our HoneyBook Inquiry Form
                                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                            </a>
                            <p className="mt-3 text-sm text-[#6E5B3D]/80">
                                Our official booking form — takes about two minutes.
                            </p>
                        </Reveal>
                        <Reveal delay={0.25}>
                            <div className="mt-8 space-y-4">
                                {ASSURANCES.map((a) => (
                                    <div key={a.text} className="flex items-center gap-3 text-[#554011]">
                                        <a.icon className="w-5 h-5 text-[#C18E8B]" />
                                        <span className="text-sm">{a.text}</span>
                                    </div>
                                ))}
                            </div>
                            <a
                                href={GOOGLE_BUSINESS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="book-google-reviews-badge"
                                className="mt-10 block bg-[#FFD2CE]/40 border border-[#E8C4C1] rounded-2xl p-6 hover:border-[#C18E8B] hover:shadow-md transition-all duration-300"
                            >
                                <div className="flex gap-1 mb-3">
                                    {[...Array(5)].map((_, s) => (
                                        <Star key={s} className="w-5 h-5 fill-[#D4A359] text-[#D4A359]" />
                                    ))}
                                </div>
                                <p className="font-display text-xl text-[#2D230A] leading-snug">
                                    See our 5-star reviews on Google
                                </p>
                                <p className="mt-2 font-accent text-xs uppercase tracking-[0.18em] text-[#6E5B3D]">
                                    Enchanting Escapes · McKinney, TX
                                </p>
                            </a>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-3">
                        <Reveal delay={0.2}>
                            <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#6E5B3D] mb-4">
                                Or send a quick note here
                            </p>
                            <InquiryForm defaultPackage={location.state?.package} />
                        </Reveal>
                    </div>
                </div>
            </section>
        </main>
    );
}
